// extracted by mini-css-extract-plugin
export default {"button":"CanvasElementButton_button__iMgyH"};